module.exports = __webpack_public_path__ + "static/media/figma.b35f01b8.png";